'use strict';

// Note: This file contains country codes for countries WITH postal code systems,
// The list was extracted from the UPU document
// https://www.upu.int/UPU/media/upu/documents/PostCode/General-Addressing-Issues.pdf

module.exports = [
  'AD', // Andorra
  'AE', // United Arab Emirates
  'AF', // Afghanistan
  'AI', // Anguilla
  'AL', // Albania
  'AM', // Armenia
  'AR', // Argentina
  'AS', // American Samoa
  'AT', // Austria
  'AU', // Australia
  'AX', // Åland Islands
  'AZ', // Azerbaijan
  'BA', // Bosnia and Herzegovina
  'BB', // Barbados
  'BD', // Bangladesh
  'BE', // Belgium
  'BH', // Bahrain
  'BM', // Bermuda
  'BN', // Brunei Darussalam
  'BR', // Brazil
  'BT', // Bhutan
  'BY', // Belarus
  'CA', // Canada
  'CH', // Switzerland
  'CL', // Chile
  'CN', // China
  'CO', // Colombia
  'CR', // Costa Rica
  'CU', // Cuba
  'CV', // Cabo Verde
  'CX', // Christmas Island
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DE', // Germany
  'DJ', // Djibouti
  'DK', // Denmark
  'DO', // Dominican Republic
  'DZ', // Algeria
  'EC', // Ecuador
  'EE', // Estonia
  'EG', // Egypt
  'EH', // Western Sahara
  'ES', // Spain
  'ET', // Ethiopia
  'FI', // Finland
  'FK', // Falkland Islands
  'FM', // Federated States of Micronesia
  'FO', // Faroe Islands
  'FR', // France
  'GA', // Gabon
  'GB', // United Kingdom
  'GE', // Georgia
  'GG', // Guernsey
  'GH', // Ghana
  'GI', // Gibraltar
  'GL', // Greenland
  'GN', // Guinea
  'GP', // Guadeloupe
  'GS', // South Georgia and South Sandwich Islands
  'GT', // Guatemala
  'GU', // Guam
  'GW', // Guinea-Bissau
  'HK', // Hong Kong
  'HM', // Heard Island and McDonald Islands
  'HN', // Honduras
  'HR', // Croatia
  'HT', // Haiti
  'HU', // Hungary
  'ID', // Indonesia
  'IE', // Ireland
  'IL', // Israel
  'IM', // Isle of Man
  'IN', // India
  'IO', // British Indian Ocean Territory
  'IQ', // Iraq
  'IR', // Iran
  'IS', // Iceland
  'IT', // Italy
  'JE', // Jersey
  'JO', // Jordan
  'JP', // Japan
  'KE', // Kenya
  'KG', // Kyrgyzstan
  'KI', // Kiribati
  'KN', // Saint Kitts and Nevis
  'KP', // Korea (Democratic People's Republic)
  'KR', // Korea (Republic)
  'KW', // Kuwait
  'KY', // Cayman Islands
  'KZ', // Kazakhstan
  'LA', // Laos
  'LB', // Lebanon
  'LC', // Saint Lucia
  'LI', // Liechtenstein
  'LK', // Sri Lanka
  'LR', // Liberia
  'LS', // Lesotho
  'LT', // Lithuania
  'LU', // Luxembourg
  'LV', // Latvia
  'MA', // Morocco
  'MC', // Monaco
  'MD', // Moldova
  'ME', // Montenegro
  'MF', // Saint Martin (French part)
  'MG', // Madagascar
  'MH', // Marshall Islands
  'MK', // North Macedonia
  'MO', // Macao
  'MP', // Northern Mariana Islands
  'MQ', // Martinique
  'MS', // Montserrat
  'MT', // Malta
  'MU', // Mauritius
  'MW', // Malawi
  'MX', // Mexico
  'MY', // Malaysia
  'MZ', // Mozambique
  'NA', // Namibia
  'NC', // New Caledonia
  'NE', // Niger
  'NF', // Norfolk Island
  'NG', // Nigeria
  'NI', // Nicaragua
  'NL', // Netherlands
  'NO', // Norway
  'NP', // Nepal
  'NR', // Nauru
  'NU', // Niue
  'NZ', // New Zealand
  'OM', // Oman
  'PA', // Panama
  'PE', // Peru
  'PG', // Papua New Guinea
  'PH', // Philippines
  'PK', // Pakistan
  'PL', // Poland
  'PM', // Saint Pierre and Miquelon
  'PN', // Pitcairn Islands
  'PR', // Puerto Rico
  'PS', // Palestine
  'PT', // Portugal
  'PW', // Palau
  'PY', // Paraguay
  'RE', // Réunion
  'RI', // Rhode Island
  'RO', // Romania
  'RS', // Serbia
  'RU', // Russian Federation
  'SA', // Saudi Arabia
  'SD', // Sudan
  'SE', // Sweden
  'SG', // Singapore
  'SH', // Saint Helena
  'SI', // Slovenia
  'SJ', // Svalbard and Jan Mayen
  'SK', // Slovakia
  'SM', // San Marino
  'SN', // Senegal
  'SZ', // Eswatini
  'TC', // Turks and Caicos Islands
  'TF', // French Southern Territories
  'TH', // Thailand
  'TJ', // Tajikistan
  'TL', // Timor-Leste
  'TM', // Turkmenistan
  'TN', // Tunisia
  'TR', // Türkiye
  'TT', // Trinidad and Tobago
  'TW', // Taiwan
  'TZ', // Tanzania
  'UA', // Ukraine
  'UG', // Uganda
  'UM', // United States Minor Outlying Islands
  'US', // United States of America
  'UY', // Uruguay
  'UZ', // Uzbekistan
  'VA', // Vatican City
  'VC', // Saint Vincent and the Grenadines
  'VE', // Venezuela
  'VG', // Virgin Islands, British
  'VI', // Virgin Islands, U.S.
  'VN', // Viet Nam
  'WF', // Wallis and Futuna
  'WS', // Samoa
  'XD', // Diego Garcia
  'XK', // Kosovo
  'YT', // Mayotte
  'ZA', // South Africa
  'ZM', // Zambia
  'ZW' // Zimbabwe
];
